import React from 'react';
import UptimeGeneralDialog from '../../dialogComponents/generalDialog/generalDialog';

interface VideoDialogProps {
  src: string;
  [key: string]: any;
}

const VideoDialog = (props: VideoDialogProps) => {
  const { src , ...dialogProps } = props;

  return (
    <UptimeGeneralDialog
      content={
        <video width="100%" controls>
          <source src={src} />
        </video>
      }
      maxWidth="md"
      headerBackgroundDefault={false}
      hideButtonCancel
      buttonSubmit={null}
      handleClose={()=>{}}
      {...dialogProps}
    />
  );
};

export default VideoDialog;
